import React, {useState} from 'react';

import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export interface GenerativeAiCheckRegistrationState {
  code?: string;
}

interface GaiCheckResponse {
  generativeAiCheckRegistration: GenerativeAiCheckRegistrationState;
}

type RegistrationStateType = {
  checkRegistrationState: GenerativeAiCheckRegistrationState;
  busy: boolean;
  checkRegistration: (skipBusy?: boolean) => Promise<GaiCheckResponse>;
  resetRegistrationCheck: () => Promise<void>;
}

export function useGenerativeAICheckRegistrationHook(): RegistrationStateType {

  const [busy, setBusy] = React.useState(false);
  const [checkRegistrationState, setRegistrationState]
    = useState<GenerativeAiCheckRegistrationState>({code: null});

  async function checkRegistration(silent: boolean = false): Promise<GaiCheckResponse> {
    if (!silent) {
      setBusy(true);
    }
    try {
      const result = await makeJsonRestApiRequest<void, GaiCheckResponse>(
        {config: {
            restApiVersion: '3.24',
            httpMethod: 'GET',
            endpoint: `gai/registration/check`,
            serverWideRequest: false
          }, request: null, queryParams: null }
      );
      if (!silent) {
        setBusy(false);
        setRegistrationState({code: result.generativeAiCheckRegistration.code});
      }
      return result;
    } catch {
      if (!silent) {
        setBusy(false);
        setRegistrationState({code: '1'});
      }
      return {generativeAiCheckRegistration: {code: '1'}};
    }
  }

  async function resetRegistrationCheck(): Promise<void> {
    setRegistrationState({code: null});
  }

  return {checkRegistrationState, busy, checkRegistration, resetRegistrationCheck};
}
